import React from "react";
import { FaShoppingCart, FaBoxes, FaMoneyBillWave, FaUser } from "react-icons/fa";
import tw from "tailwind-styled-components";

function SummaryCards({ summaryData }) {
    const cards = [
        {
            amount: summaryData?.totalTransfer || 0,
            label: "Total Transfers",
            color: "text-black",
            icon: <FaShoppingCart className="text-blue-500" size={20} />,
        },
        {
            amount: summaryData?.totalItemTransfer || 0,
            label: "Total Items",
            color: "text-black",
            icon: <FaBoxes className="text-green-500" size={20} />,
        },
        {
            amount: "₹" + (summaryData?.totalTransferAmount || 0),
            label: "Total Amount",
            color: "text-black",
            icon: <FaMoneyBillWave className="text-purple-500" size={20} />,
            isCurrency: true,
        },
        {
            amount: summaryData?.totalKitchenTransferredTo || 0,
            label: "Kitchens",
            color: "text-black",
            icon: <FaUser className="text-orange-500" size={20} />,
        },
    ];

    return (
        <Wrapper>
            <ScrollCard>
                {cards.map((item, index) => (
                    <Card key={index}>
                        <ValueRow>
                            <Value color={item.color}>
                                {item.amount}
                            </Value>
                        </ValueRow>
                        <Label>{item.label}</Label>
                    </Card>
                ))}
            </ScrollCard>
        </Wrapper>
    );
}

const Wrapper = tw.div`w-full`;
const ScrollCard = tw.div`w-full overflow-x-auto flex space-x-4 py-1`;
const IconWrapper = tw.div`ml-2`;

const Card = tw.div`
    group min-w-[200px]
    rounded-lg bg-white
    p-4 
    border border-gray-100
    shadow-sm
    transition-all duration-200
    hover:shadow-md hover:border-gray-200
    ${({ $selected }) =>
        $selected
            ? "border-primary-color shadow-md"
            : ""}
`;

const ValueRow = tw.div`
    flex items-baseline gap-1
`;

const Value = tw.div`
    text-xl font-semibold text-gray-900
    ${({ color }) => color || "text-gray-900"}
`;

const Label = tw.div`
    flex mt-2 text-sm text-gray-500 items-center justify-between
`;



export default SummaryCards;